import React, {useState} from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../ui/Dialog/DialogActions";
import Button from "../../../../../../../ui/Button";
import DepartmentsEditForm from "../DepartmentsEditForm";

const styles = () => ({
  dialog: {
    width: "550px"
  }
});

const DepartmentsEditModal = ({
  open,
  handleClose,
  classes,
  orgId,
  departmentsList,
  onUpdate
}) => {
  const [formData, updateFormData] = useState(null);

  const onConfirm = () => {
    onUpdate(orgId, formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Редактировать подразделения</DialogTitle>
        <DialogContent>
          <DepartmentsEditForm orgId={orgId} departmentsList={departmentsList}
                          onFormChange={updateFormData}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            //loading={isCreatingRoom}
            disabled={!formData}
            onClick={() => onConfirm()}
            color="green"
          >
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(DepartmentsEditModal));
